import React from "react"
import styled from "styled-components"
import { Button as AntdButton, Progress as AntdProgress, Icon } from "antd"
import { FormNavigationContext } from "../Panes/Form"
import { colors } from "../../components/Color"
import { media } from "../../components/mediaStylesNew"

const Wrapper = styled.div`
  width: 100%;
  height: 60px;
  background: ${colors.paleBeige};

  ${props =>
    props.fixed &&
    `
    box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.3);
    position: fixed;
    z-index: 27;
    bottom: 0;
    left: 0;
  `}

  z-index: 1000;
`

const BottomBar = styled.div`
  height: 100%;
  background: ${colors.paleBeige};
  max-width: 800px;
  margin: auto;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;

  > * {
    margin-right: 20px;
  }

  ${props =>
    props.fixed &&
    `
    justify-content: space-between;
    padding: 15px;
    > * {
    padding: 0 15px;
    margin-right: 0;
    }
  `}

  ${media.small`
      padding: 0 15px;
    `}
`

const Button = styled(AntdButton)`
  font-family: GT America, sans-serif;
  font-size: 16px !important;
  height: 50px !important;
  @media (min-width: 66.875em) {
    width: 200px !important;
  }
  background: ${colors.grey} !important;
  ${media.largerPhone`
    width: 100px !important;
    font-size: 14px !important;
`}

  &:hover {
    color: ${colors.teal} !important;
    border-color: ${colors.teal} !important;
  }
`

const ForwardButton = styled(Button)`
  position: relative;
  background: ${colors.teal} !important;
  color: ${colors.tertiary} !important;

  &:hover {
    color: ${colors.white} !important;
    border-color: ${colors.teal} !important;
  }
`

const ProgressBar = styled.div`
  position: absolute;
  width: 100%;
  bottom: -2px;
  left: 0;
  display: inline-flex;
`

const Progress = styled(AntdProgress)`
  font-family: GT America, sans-serif;
  .ant-progress-outer {
    display: flex !important;
  }
`

const PercentageValue = styled.div`
  font-family: GT America, sans-serif;
  font-size: 20px;
  ${media.largerPhone`
    font-size: 16px;
`}
`

const EnterHint = styled.div`
  ${media.small`
    display: none;
  `};
  display: block;
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translate3D(100%, -50%, 0);
  font-weight: 400;
  text-align: left;
  font-size: 14px;
`

export default class NavigationBar extends React.Component {
  componentWillMount() {
    this.listener = document.addEventListener("keypress", this.onButtonClick, {
      capture: false,
    })
  }

  componentWillUnmount() {
    document.removeEventListener("keypress", this.onButtonClick)
  }

  onButtonClick = event => {
    if (
      (event.which == 13 || event.keyCode == 13) &&
      event.target.nodeName !== "TEXTAREA"
    ) {
      this.props.onNext()
    }
  }

  render() {
    return (
      <FormNavigationContext.Consumer>
        {value =>
          value.navigationVisible ? (
            <Wrapper fixed={this.props.fixed}>
              <BottomBar fixed={this.props.fixed}>
                {value.percentage > 0 ? (
                  <Button onClick={this.props.onBack}>Zurück</Button>
                ) : this.props.fixed ? (
                  <span />
                ) : null}
                {value.percentage && this.props.fixed && (
                  <PercentageValue>
                    {Math.floor(value.percentage)} %
                  </PercentageValue>
                )}
                <ForwardButton onClick={this.props.onNext}>
                  Weiter
                  <EnterHint>
                    Enter <Icon type="enter" />
                    <br /> drücken
                  </EnterHint>
                </ForwardButton>
                {this.props.shouldShowProgress &&
                  value.percentage &&
                  !this.props.fixed && (
                    <Progress
                      type="circle"
                      strokeLinecap="square"
                      percent={Math.floor(value.percentage)}
                      width="45px"
                      strokeColor={colors.quaternary}
                    />
                  )}
              </BottomBar>
              {this.props.shouldShowProgress && this.props.fixed && (
                <ProgressBar>
                  <Progress
                    strokeLinecap="square"
                    percent={value.percentage}
                    showInfo={false}
                    strokeColor={colors.quaternary}
                  />
                </ProgressBar>
              )}
            </Wrapper>
          ) : null
        }
      </FormNavigationContext.Consumer>
    )
  }
}
NavigationBar.defaultProps = {
  onBack: () => {},
  onNext: () => {},
  fixed: true,
  showProgress: true,
}
